module.exports = __webpack_public_path__ + "img/ciclo_cheques.240dca85.png";